let CmnCarousel = {}

CmnCarousel.install = function install (Vue) {
    Vue.component('cmn-carousel', () => import('./CmnCarousel'))
    Vue.component('cmn-carousel-testimonials', () => import('./CmnCarouselTestimonials'))
    Vue.component('cmn-carousel-slide', () => import('./CmnCarouselSlide'))
    Vue.component('cmn-carousel-testimonials-pro', () => import('./CmnCarouselTestimonialsPro'))
}

export default CmnCarousel


// WEBPACK FOOTER //
// ./application/assets/js/site/components/CmnCarousel/index.js